import { render, staticRenderFns } from "./media.template?vue&type=template&id=dfe1e776&scoped=true&lang=pug&"
import script from "./media.client?vue&type=script&lang=ts&"
export * from "./media.client?vue&type=script&lang=ts&"
import style0 from "./media.style?vue&type=style&index=0&id=dfe1e776&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe1e776",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfe1e776')) {
      api.createRecord('dfe1e776', component.options)
    } else {
      api.reload('dfe1e776', component.options)
    }
    module.hot.accept("./media.template?vue&type=template&id=dfe1e776&scoped=true&lang=pug&", function () {
      api.rerender('dfe1e776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/attachments/viewer/media/media.component.vue"
export default component.exports